import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProducts, fetchFeaturedProduct } from "../actions/product";
import Loader from "../components/loader";
import Message from "../components/message";
import SearchBox from "../components/searchBox";
import { Route } from "react-router-dom";
import Paginate from "../components/paginate";
import Carousel from "../Utils/Home/Carousel";
import ProductHighlights from "../Utils/Home/ProductHighlights";
import ProductCard from "../Utils/Home/ProductCard";
import HotSale from "../Utils/Home/HotSale";
import Subscribe from "../Utils/Home/Subscribe";

const NewArrivalsScreen = ({ match }) => {
  const keyword = match.params.keyword;
  const pageNumber = match.params.pageNumber || 1;
  const dispatch = useDispatch();
  const productList = useSelector((state) => state.productList);

  const { loading, error, products, page, pages } = productList;
  console.log("productslist___", products);

  const { loading: carouselLoaded } = useSelector(
    (state) => state.latestProducts
  );

  useEffect(() => {
    dispatch(fetchAllProducts(keyword, pageNumber));
  }, [dispatch, keyword, pageNumber]);

  useEffect(() => {
    dispatch(fetchFeaturedProduct());
  }, []);

  return (
    <>
      {/* {keyword && (
        <Route
          render={({ history }) => (
            <SearchBox
              history={history}
              placeholder="Search products by name, style or category"
            />
          )}
        />
      )} */}
      <Carousel />
      <section id="company-services" style={{ padding: "7em 0px" }}>
        <div className="container">
          <ProductHighlights />
        </div>
      </section>

      {products ? (
        <>
          <Container className="my-2" id="mobileListing">
            <Row className="d-flex flex-wrap">
              <div class="display-header d-flex justify-content-between pb-3">
                <h2 class="display-7 text-uppercase">Mobile Products</h2>
              </div>

              {products.map((product) => (
                <>
                  <Col
                    key={product._id}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    className="mb-4"
                  >
                    <ProductCard product={product} menu={product.menu} />
                  </Col>
                </>
              ))}
            </Row>
          </Container>

          <Paginate
            pages={pages}
            page={page}
            keyword={keyword ? keyword : ""}
          />
        </>
      ) : !carouselLoaded && loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : null}

      <HotSale />
      <Subscribe />
    </>
  );
};

export default NewArrivalsScreen;
